import React, { Component } from 'react';
import styles from './styles';

import { AxlInput, AxlPanel, AxlReselect, AxlDateInput, AxlCheckbox, AxlButton, AxlSelect } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";
import _ from "lodash";
import CurrencyInput from '../../CurrencyInput';
import { currencyOptions } from  '../../ShipmentValueInfoForm/validCurrencyCodes';
import AxlReactSelect from "../../AxlReactSelect";

@inject('jobStore')
@observer
class ShipmentEditForm extends Component {
  state = {
    oldValue: {},
    responseError: {},
  };

  componentDidMount() {
    const { shipmentForm } = this.props.jobStore;

    this.setState({oldValue: JSON.parse(JSON.stringify(shipmentForm.data))});
  }

  closeWithoutSaving = () => {
    const { shipmentForm } = this.props.jobStore;
    const { oldValue } = this.state;

    shipmentForm.setData(oldValue);
    this.props.closeForm();
  };

  save = (e) => {
    const {jobStore, closeForm} = this.props;
    jobStore.updateDraftShipment((shipment, job) => {
      closeForm();
    }, (response) => {
      // On error
      this.setState({
        responseError: {
          code: response.status,
          msg: response.data && response.data.errors ? response.data.errors.join(' ') : 'Fail to update shipment info!',
        }
      })
    });
  };

  render() {
    const { jobStore } = this.props;
    const { responseError } = this.state;
    const { shipmentForm, updatingShipment } = jobStore;
    const isPickupError = !shipmentForm.getField('pickup_address.lat', null) ||
      !shipmentForm.getField('pickup_address.lng', null);

    const isDropoffError = !shipmentForm.getField('dropoff_address.lat', null) ||
      !shipmentForm.getField('dropoff_address.lng', null);

    const pickup_earliest_ts = {
      maxDate: shipmentForm.getField('dropoff_latest_ts', null),
      dateFormat: 'MM/DD/YYYY HH:mm A',
      placeHolder: 'Earliest Pickup',
      enableTime: true,
      altInput: false,
      clickOpens: true,
      altInputClass: 'form-conrol',
      defaultValue: shipmentForm.getField('pickup_earliest_ts', null)
    },
    pickup_latest_ts = {
      minDate: shipmentForm.getField('pickup_earliest_ts', null),
      maxDate: shipmentForm.getField('dropoff_latest_ts', null),
      dateFormat: 'MM/DD/YYYY HH:mm A',
      placeHolder: 'Earliest Pickup',
      enableTime: true,
      altInput: false,
      clickOpens: true,
      altInputClass: 'form-conrol',
      defaultValue: shipmentForm.getField('pickup_latest_ts', null)
    },
    dropoff_earliest_ts = {
      maxDate: shipmentForm.getField('dropoff_latest_ts', null),
      dateFormat: 'MM/DD/YYYY HH:mm A',
      placeHolder: 'Earliest Pickup',
      enableTime: true,
      altInput: false,
      clickOpens: true,
      altInputClass: 'form-conrol',
      defaultValue: shipmentForm.getField('dropoff_earliest_ts', null)
    },
    dropoff_latest_ts = {
      minDate: shipmentForm.getField('dropoff_earliest_ts', null),
      dateFormat: 'MM/DD/YYYY HH:mm A',
      placeHolder: 'Earliest Pickup',
      enableTime: true,
      altInput: false,
      clickOpens: true,
      altInputClass: 'form-conrol',
      defaultValue: shipmentForm.getField('dropoff_latest_ts', null)
    };
    const currentCurrencyValue = currencyOptions.find(c=>c.value === shipmentForm.getField('currency', ' '));

    return <div style={styles.Container}>
      <div style={styles.HeaderTitle}>{`Edit Shipment Details`}</div>
      <AxlPanel>
        <div style={styles.GroupTitle}>{`CUSTOMER INFORMATION`}</div>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <div style={styles.GroupField}>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('customer.name', '')} onChange={shipmentForm.handlerInput} placeholder={`Name`} name={`customer.name`} type={`text`} fluid /></div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('customer.email', '')}  onChange={shipmentForm.handlerInput} placeholder={`Email Address`} name={`customer.email`} type={`email`} fluid /></div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('customer.phone_number', '')}  onChange={shipmentForm.handlerInput} placeholder={`Phone Number`} name={`customer.phone_number`} type={`text`} fluid /></div>
            </div>
          </AxlPanel.Col>
          <AxlPanel.Col />
        </AxlPanel.Row>
        <div style={styles.GroupTitle}>{`SHIPMENT VALUE`}</div>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <div style={styles.GroupField}>
            <AxlPanel.Row align={`center`}>
              <AxlPanel.Col><div style={styles.Field}>
                <CurrencyInput style={{...styles.moneyInput}} 
                      type="text"                    
                      value={shipmentForm.getField('value', '')} 
                      onChange={shipmentForm.handlerInput}  
                      name='value'
                      required
                    /></div>
              </AxlPanel.Col>                    
              <AxlPanel.Col> <div style={styles.Field}>
                <AxlReactSelect
                    name='currency'
                    options={currencyOptions}
                    value={currentCurrencyValue}
                    maxMenuHeight="75"
                    onChange={(selected)=>{
                      shipmentForm.setField('currency',selected.value)}
                    }
                />
                </div>         
              </AxlPanel.Col>
              <AxlPanel.Col></AxlPanel.Col>              
            </AxlPanel.Row>
            </div>
          </AxlPanel.Col>
          <AxlPanel.Col />
        </AxlPanel.Row>        
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <div style={styles.GroupField}>
              <div style={styles.Title}>{`PICKUP INFORMATION`}</div>
              <div style={styles.GroupTitle}>{`TIME WINDOW`}</div>
              <AxlPanel.Row align={`center`}>
                <AxlPanel.Col><div style={styles.Field}><AxlDateInput onChange={shipmentForm.handlerDateInput('pickup_earliest_ts')} displayToday={false} options={pickup_earliest_ts} theme={`main`} /></div></AxlPanel.Col>
                <AxlPanel.Col flex={0}><div style={{...styles.Field, ...styles.labelHours}}>{`< 0.0 HOURS >`}</div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlDateInput onChange={shipmentForm.handlerDateInput('pickup_latest_ts')} displayToday={false} options={pickup_latest_ts} theme={`main`} /></div></AxlPanel.Col>
              </AxlPanel.Row>
            </div>
          </AxlPanel.Col>
          <AxlPanel.Col>
            <div style={styles.GroupField}>
              <div style={styles.Title}>{`DROPOFF INFORMATION`}</div>
              <div style={styles.GroupTitle}>{`TIME WINDOW`}</div>
              <AxlPanel.Row align={`center`}>
                <AxlPanel.Col><div style={styles.Field}><AxlDateInput onChange={shipmentForm.handlerDateInput('dropoff_earliest_ts')} displayToday={false} options={dropoff_earliest_ts} theme={`main`} /></div></AxlPanel.Col>
                <AxlPanel.Col flex={0}><div style={{...styles.Field, ...styles.labelHours}}>{`< 0.0 HOURS >`}</div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlDateInput onChange={shipmentForm.handlerDateInput('dropoff_latest_ts')} displayToday={false} options={dropoff_latest_ts} theme={`main`} /></div></AxlPanel.Col>
              </AxlPanel.Row>
            </div>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <div style={styles.GroupField}>
              <div style={styles.GroupTitle}>{`ADDRESS`}</div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.street', '')} onChange={shipmentForm.handlerInput} error={isPickupError} placeholder={`Pickup Street`} name={`pickup_address.street`} type={`text`} fluid /></div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.street2', '')} onChange={shipmentForm.handlerInput} error={isPickupError} placeholder={`Pickup Street 2`} name={`pickup_address.street2`} type={`text`} fluid /></div>
              <AxlPanel.Row align={`center`}>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.city', '')} onChange={shipmentForm.handlerInput} error={isPickupError} placeholder={`Pickup City`} name={`pickup_address.city`} type={`text`} fluid /></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.state', '')} onChange={shipmentForm.handlerInput} error={isPickupError} placeholder={`Pickup State`} name={`pickup_address.state`} type={`text`} fluid /></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.zipcode', '')} onChange={shipmentForm.handlerInput} error={isPickupError} placeholder={`Pickup Zipcode`} name={`pickup_address.zipcode`} type={`text`} fluid /></div></AxlPanel.Col>
              </AxlPanel.Row>
              {/*<AxlPanel.Row align={`center`}>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.lat', '')} onChange={shipmentForm.handlerInput} placeholder={`Pickup latitude`} name={`pickup_address.lat`} type={`text`} fluid /></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_address.lng', '')} onChange={shipmentForm.handlerInput} placeholder={`Pickup longtitude`} name={`pickup_address.lng`} type={`text`} fluid /></div></AxlPanel.Col>
              </AxlPanel.Row>*/}
            </div>
          </AxlPanel.Col>
          <AxlPanel.Col>
            <div style={styles.GroupField}>
              <div style={styles.GroupTitle}>{`ADDRESS`}</div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.street', '')} onChange={shipmentForm.handlerInput} error={isDropoffError} placeholder={`Dropoff Street`} name={`dropoff_address.street`} type={`text`} fluid /></div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.street2', '')} onChange={shipmentForm.handlerInput} error={isDropoffError} placeholder={`Dropoff Street 2`} name={`dropoff_address.street2`} type={`text`} fluid /></div>
              <AxlPanel.Row align={`center`}>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.city', '')} onChange={shipmentForm.handlerInput} error={isDropoffError} placeholder={`Dropoff City`} name={`dropoff_address.city`} type={`text`} fluid /></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.state', '')} onChange={shipmentForm.handlerInput} error={isDropoffError} placeholder={`Dropoff State`} name={`dropoff_address.state`} type={`text`} fluid /></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.zipcode', '')} onChange={shipmentForm.handlerInput} error={isDropoffError} placeholder={`Dropoff Zipcode`} name={`dropoff_address.zipcode`} type={`text`} fluid /></div></AxlPanel.Col>
              </AxlPanel.Row>
              {/*<AxlPanel.Row align={`center`}>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.lat', '')} onChange={shipmentForm.handlerInput} placeholder={`Dropoff latitude`} name={`dropoff_address.lat`} type={`text`} fluid /></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_address.lng', '')} onChange={shipmentForm.handlerInput} placeholder={`Dropoff longtitude`} name={`dropoff_address.lng`} type={`text`} fluid /></div></AxlPanel.Col>
              </AxlPanel.Row>*/}
            </div>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <div style={styles.GroupField}>
              <div style={styles.GroupTitle}>{`NOTES`}</div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('pickup_note', '')} onChange={shipmentForm.handlerInput} placeholder={`Pickup Notes`} name={`pickup_note`} type={`text`} fluid /></div>
            </div>
          </AxlPanel.Col>
          <AxlPanel.Col>
            <div style={styles.GroupField}>
              <div style={styles.GroupTitle}>{`NOTES`}</div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('dropoff_note', '')} onChange={shipmentForm.handlerInput} placeholder={`Dropoff Notes`} name={`dropoff_note`} type={`text`} fluid /></div>
            </div>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <div style={styles.GroupField}>
              <div style={styles.GroupTitle}>{`DELIVERY ITEMS`}</div>
              <div style={styles.Field}><AxlInput value={shipmentForm.getField('delivery_items', '')} onChange={shipmentForm.handlerInput} placeholder={`Delivery Items`} name={`delivery_items`} type={`text`} fluid /></div>
            </div>
          </AxlPanel.Col>
          <AxlPanel.Col>
            <div style={styles.GroupTitle}>{`Check the required services`.toUpperCase()}</div>
            <div style={styles.GroupField}>
              <AxlPanel.Row>
                <AxlPanel.Col><div style={styles.Field}><AxlCheckbox name={`delivery_proof_photo_required`} checked={shipmentForm.getField('delivery_proof_photo_required', false)} onChange={shipmentForm.handlerCheckbox} color={`periwinkle`} theme={`secondary`}>{`Photo POD`}</AxlCheckbox></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlCheckbox name={`signature_required`} checked={shipmentForm.getField('signature_required', false)} onChange={shipmentForm.handlerCheckbox} color={`periwinkle`} theme={`secondary`}>{`Signature`}</AxlCheckbox></div></AxlPanel.Col>
                <AxlPanel.Col><div style={styles.Field}><AxlCheckbox name={`sms_enabled`} checked={shipmentForm.getField('sms_enabled', false)} onChange={shipmentForm.handlerCheckbox} color={`periwinkle`} theme={`secondary`}>{`Text Enabled`}</AxlCheckbox></div></AxlPanel.Col>
              </AxlPanel.Row>
            </div>
          </AxlPanel.Col>
        </AxlPanel.Row>
        {!!responseError.code && (
          <div style={styles.error}>
            {`Error ${responseError.code}: ${responseError.msg}`}
          </div>
        )}
        <AxlPanel.Row>
          <AxlPanel.Col />
          <AxlPanel.Col>
            <AxlPanel.Row align={`flex-end`}>
              <div style={{...styles.Field, ...styles.FieldButton}}><AxlButton compact bg={`gray`} onClick={this.closeWithoutSaving} style={styles.buttonControl}>{`Cancel`}</AxlButton></div>
              <div style={{...styles.Field, ...styles.FieldButton}}><AxlButton compact bg={`pink`} onClick={this.save} style={styles.buttonControl} loading={updatingShipment}>{`Save`}</AxlButton></div>
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
      </AxlPanel>
    </div>
  }
}

export default ShipmentEditForm;